import React, { useState, useRef, useEffect } from "react";
import { actions } from "react-redux-form";
import { Button, Col, Row, DropdownItem, Dropdown, DropdownToggle, DropdownMenu, Alert, Input } from "reactstrap";
import { compose, withHandlers } from "recompose";
import shortid from "shortid";
import { Trans } from "react-i18next";
import { getStatus, FormGroup, onMount, Page, required, withLocalForm, withReload } from "components/common";
import { SpanColor, cStyle, formatDateTime, format_reference, formatDate as formatedDate } from "services/util";
import { LineItemsView, withDocumentRenderer, withOptions, Payment, withXeroErrors, Attachments } from "components";
import { InvoiceDocument, SimpleSmallDocument, SimpleInvoiceDocument, SmallInvoiceDocument, PackingSlipDocument } from "components/documents";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import BackButton from "components/refactoring/BackButton";
import { Link } from "react-router-dom";
import { useConfirmModal, ZatcaClient } from "services";
import { invoiceSDKPost } from "components/common/ZatcaSendInvoice";
import { getOutlineStyle } from "pages/UserList/Edit";
import { useBaseModal } from "services";
import { DownloadError, isValidContactDetails } from "components/common/ZatcaSelected";
import useNoTaxHandler from "./useNoTaxHandler";
import HistoryComponent from "components/ShowHistoryComponent";
import { useTaxExemptChecker } from "./useTaxExemptChecker";
import { useZatcaAppsChecker } from "./useZatcaAppsChecker";
import { ErrorDetailsComponent } from "components/common/ErrorDetailsComponent";
import { useLocation } from "react-router";
import { useQuery } from "react-query";

export const formatDateName = (dateString) => {
  const options = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(new Date(dateString));

  return formattedDate.replace(/(\d)(st|nd|rd|th)/, (_, digit, suffix) => `${digit}<sup>${suffix}</sup>`);
};

const PackingSlipCell = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `s_${item.InvoiceNumber}.pdf`,
    ),
})(({ PackingSlipDocument, DocumentRenderer, i, componentDoc, selectedOrganisation, simplified }) => (
  <td className="text-end text-left">
    <PackingSlipDocument item={i} />
    <DocumentRenderer component={componentDoc} selectedOrganisation={selectedOrganisation} />
  </td>
));

const PrintCell = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `small_${item.InvoiceNumber}.pdf`,
    ),
})(({ PrintDocument, DocumentRenderer, i, componentDoc, selectedOrganisation, simplified }) => (
  <td className="text-end text-left">
    <PrintDocument item={i} is_small={true} simplified={simplified} />
    <DocumentRenderer component={componentDoc} selectedOrganisation={selectedOrganisation} />
  </td>
));

const ShareCell = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `Invoice_${item.InvoiceNumber}.pdf`,
    ),
})(({ DocumentRenderer, ShareDocument, i, componentDoc, selectedOrganisation, simplified, validation, setDownloadHandler }) => (
  <td className="text-end text-left">
    <ShareDocument item={i} wtsp={true} simplified={simplified} validation={validation} setDownloadHandler={setDownloadHandler} />
    <DocumentRenderer component={componentDoc} selectedOrganisation={selectedOrganisation} />
  </td>
));

const DownloadCell = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `Invoice_${item.InvoiceNumber}.pdf`,
    ),
  type: "SALES_INVOICE",
})(({ DownloadDocument, DocumentRenderer, i, componentDoc, type, selectedOrganisation, simplified, validation, setDownloadHandler }) => (
  <>
    <DownloadDocument item={i} simplified={simplified} validation={validation} setDownloadHandler={setDownloadHandler} className="mr-1" />
    <DocumentRenderer component={componentDoc} type={type} selectedOrganisation={selectedOrganisation} />
  </>
));

const EmailCell = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `Invoice_${item.InvoiceNumber}.pdf`,
    ),

})(({ EmailDocument, DocumentRenderer, i, componentDoc, type, selectedOrganisation, simplified, validation, setDownloadHandler }) => (
  <>
    <EmailDocument type={"SALES_INVOICE"} item={i} simplified={simplified} validation={validation} setDownloadHandler={setDownloadHandler} className="mr-1" />
    <DocumentRenderer component={componentDoc} type={type} selectedOrganisation={selectedOrganisation} />
  </>
));

export const ViewEInvoice = ({
  item,
  LocalForm,
  onSubmit,
  xero,
  dispatch,
  handlePaymentAdded,
  handleAttachmentsChanged,
  XeroErrors,
  organisation,
  DocumentRenderer,
  DownloadDocument,
  EmailDocument,
  t,
  history,
  invHistory,
  prepayments,
  InvoiceOptions,
  selectedOrganisation,
  reload,
}) => {

  const [items, setItems] = useState({ ...item, Reference: format_reference(item.Reference) })
  const zatca = ZatcaClient()

  const pageTakeOver = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isPaymentVisible, setPaymentVisibility] = useState(false);
  const [useSimpleType, setSimpleType] = useState(item.DocumentType === 'simplified');
  const documentType = useSimpleType ? "simplified" : "standard";
  const [invoiceSDKZatca, setSDKZatcaData] = useState(null);
  const [reportedList, setReportedList] = useState();
  const [, toggle, MainModal] = useBaseModal()
  const [errorWindow, setErrorWindow] = useState(false);


  const location = useLocation();
  const urlParams = new URLSearchParams(location?.search);
  const auto_report = urlParams.get("auto_report");

  const isZatcaSubscribed = selectedOrganisation?.subscribed_features?.hesaabmodule?.includes('wpconnect')
  const hasZatcaAccess = (selectedOrganisation?.country?.toLowerCase() === 'sa' && selectedOrganisation?.zatca_phase_one_enabled) || isZatcaSubscribed
  const [selectedZatcaApp, setSelectedZatcaApp] = useState();

  const CanReport = ((item.Status === "AUTHORISED" || item.Status === "PAID"))
  const IsReported = reportedList?.reported || reportedList?.cleared
  const { preGetInvoiceXML, preHandleSDKPost, NoTaxComponent, isSending, refreshFlag, setDocument, zatcaApps } = useNoTaxHandler(t, "invoice", reload)
  const [checkZeroTaxLines, TaxExemptComponent] = useTaxExemptChecker(t, isZatcaSubscribed, item, reload, CanReport && !IsReported && !auto_report)
  const [selectApp, ZatcaAppsComponent] = useZatcaAppsChecker(t, isZatcaSubscribed, setSelectedZatcaApp, CanReport && !IsReported)

  const [, toggleResend, MainResendModal, setCallback] = useConfirmModal()


  const historyItem = invHistory.HistoryRecords;
  const selectedType = useSimpleType ? SimpleInvoiceDocument : InvoiceDocument;
  const selectedPrintCell = useSimpleType ? SimpleSmallDocument : SmallInvoiceDocument;

  const { data: print_templates } = useQuery("print_templates", () => xero.get("all/invoice_settings").get("data").get("invoice_layout_settings"), {
  });

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const togglePaymentVisibility = () => {
    setPaymentVisibility(!isPaymentVisible);
  };

  useEffect(() => {
    if (!isSending && !IsReported && (zatcaApps && auto_report && reportedList && CanReport && selectedOrganisation.zatca_auto_send?.enabled && hasZatcaAccess)) {
      checkZatcaResend(() => sendToZatcaHandler(invoiceSDKZatca, true, preHandleSDKPost))
    }
  }, [reportedList, zatcaApps])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseSDK = await zatca.get(`reports/${item?.InvoiceID}/single`);
        const reportedList = responseSDK.data;
        setReportedList(reportedList);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [item?.InvoiceID, refreshFlag]);


  const docType = "invoice"
  const invoiceType = documentType
  const formattedType = invoiceType.charAt(0).toUpperCase() + invoiceType.slice(1) + " Invoice ";
  const [callbackFunc, setCallbackFunc] = useState();

  useEffect(() => {
    if (items && isZatcaSubscribed) {
      const mappedData = invoiceSDKPost(items, docType, invoiceType);
      setSDKZatcaData(mappedData);
      setDocument(items)
    }
  }, [items, invoiceType, invoiceType]);


  const status = (() => {
    if (reportedList?.reported) {
      return "Reported";
    } else if (reportedList?.cleared) {
      return "Cleared";
    } else if (reportedList?.complied) {
      return "Complied";
    } else {
      return false;
    }
  })();

  const [missFields, setMissingFields] = useState([]);

  const validateDownload = () => {
    if (!CanReport || !hasZatcaAccess) {
      return true
    }
    if (!checkInvoiceDownload()) {
      return false
    }
    else {
      return checkZeroTaxLines() && selectApp(selectedZatcaApp)
    }
  }

  const checkInvoiceDownload = (isWtspShare = false) => {

    if (!hasZatcaAccess) {
      return true
    }

    let contactMobile = items?.Contact?.Phones?.find((phone) => phone.PhoneType === "MOBILE")
    let isValidPhoneNumber = !isWtspShare || (contactMobile.PhoneNumber && contactMobile.PhoneCountryCode)
    let isValidContactInfo = useSimpleType || isValidContactDetails({...items.Contact})

    const missing_fields = []

    if(!isValidPhoneNumber){
      missing_fields.push('PhoneNumber')
    }

    if (!isValidContactInfo) {
      missing_fields.push('ContactInfo')
    }

    setMissingFields(missing_fields)

    if (!(isValidPhoneNumber && isValidContactInfo)) {
      toggle();
      return false;
    } else {
      return true;
    }
  };


  const zatcaFuncHandler = (params, callback) => (props = {}) => {
    callback({ ...params, ...props })
    setSDKZatcaData({ ...params, ...props })
  }

  const sendToZatcaHandler = (invoiceSDKZatca, reporting, callback) => {
    let params = {
      ...invoiceSDKZatca,
      Reporting: reporting
    }

    if (!checkInvoiceDownload()) {
      setCallbackFunc(() => zatcaFuncHandler(params, callback));
      return false
    }

    zatcaFuncHandler(params, callback)()
  }

  const setDownloadHandler = (func) => {
    setCallbackFunc(() => func);
  }

  const checkZatcaResend = (callback) => {
    if (reportedList.reported || reportedList.cleared) {
      toggleResend()
      setCallback(() => callback)
    }
    else {
      callback()
    }
  }

  useEffect(() => {
    if (isPaymentVisible && pageTakeOver.current) {
      setTimeout(() => {
        const fullPageHeight = document.body.scrollHeight;
        window.scrollTo({
          top: fullPageHeight,
          behavior: 'smooth',
        });
      }, 200);
    }
  }, [isPaymentVisible]);


  return (
    <div className="nw-invoiceStyle">
      <Page
        title={
          item.InvoiceID
            ? t(`Invoice {{ InvoiceNumber }}`, {
              InvoiceNumber: item.InvoiceNumber,
            })
            : ''
        }
        translate={false}
      >
        {item && item.LineItems ? <>
          <div className="my-2 row">
            <div className="col-6">
              <BackButton />
            </div>
            <div className="col-6 text-right d-flex justify-content-end align-items-center">
              <div className="inline-block mx-1">
                {!!print_templates?.length && !!item.InvoiceID && (
                  <div>
                    <FormGroup>
                      <Input
                        type="select"
                        className="py-0 text-center"
                        onChange={(e) => setItems({ ...items, template_id: Number(e.target.value) })}
                        value={items.template_id}
                      >
                        <option value="">-- {t('Select Template')} --</option>
                        {print_templates.map((template) => (
                          <option value={template.id} key={template.id}>{template.name}</option>
                        ))}
                      </Input>
                    </FormGroup>
                  </div>
                )}
              </div>
              <div className="inline-block mx-2">
                {isZatcaSubscribed && status ? (
                  <>
                    {reportedList?.complied && <p className="mx-1 d-inline" style={getOutlineStyle('#72B566')}><Trans>Complied</Trans></p>}
                    {reportedList?.reported && <p className="mx-1 d-inline clickable" style={getOutlineStyle('#54984A')} onClick={() => setErrorWindow(true)}><Trans>Reported</Trans>
                      {reportedList?.updated_at && <span className="small"> ({formatDateTime(reportedList.updated_at)})<i className="fa fa-eye ml-1"></i></span>}
                    </p>}
                    {reportedList?.cleared && <p className="mx-1 d-inline clickable" style={getOutlineStyle('#8BD07C')} onClick={() => setErrorWindow(true)}><Trans>Cleared</Trans>
                      {reportedList?.updated_at && <span className="small"> ({formatDateTime(reportedList.updated_at)})<i className="fa fa-eye ml-1"></i></span>}
                    </p>}
                  </>
                ) :
                  reportedList?.updated_at ?
                    <span style={getOutlineStyle('#FFC107')} className="my-0 clickable" onClick={() => setErrorWindow(true)}><Trans>Not Reported</Trans><i className="fa fa-eye ml-1"></i></span>
                    :
                    <span style={getOutlineStyle('#FFC107')} className="my-0">----------</span>}
              </div>
              <div className="inline-block">
                {hasZatcaAccess && !!item.InvoiceID && (
                  <div>
                    <FormGroup>
                      <Input
                        type="select"
                        className="py-0"
                        onChange={(e) => setSimpleType(e.target.value === 'true')}
                        value={useSimpleType}
                        disabled={item.DocumentTypeConfirmed}
                      >
                        <option value={true}>
                          {t('Export: Simplified Invoice')}
                        </option>
                        <option value={false}>
                          {t('Export: Tax Invoice')}
                        </option>
                      </Input>
                    </FormGroup>
                  </div>
                )}
              </div>
            </div>
          </div>
          <XeroErrors />
          <DocumentRenderer component={selectedType} />
          <div className="actions-wrapper row justify-content-between">
            <div className="col-lg-12 col-xl-5 row justify-content-start mb-md-2 px-4">
              {!!item.InvoiceID &&
                <>
                  {/* <div className="col flex-grow-0 px-1">
                    <DocumentRenderer component={selectedType} />
                  </div> */}
                  {item.SentToContact && (
                    <div className="col flex-grow-0 px-1">
                      <div className="d-flex align-items-center" style={{ paddingBottom: 20 }}>
                        <div className="text-success small">
                          <span className="fa fa-check mr-1" /> <Trans>Sent to contact</Trans>
                        </div>
                      </div>
                    </div>
                  )}

                  {isZatcaSubscribed && CanReport && (
                    <div className="co flex-grow-0 px-1">
                      {!isSending ?
                        (<Dropdown size="sm" color="primary" className="mx-0" isOpen={dropdownOpen} toggle={toggleDropdown} disabled={isSending}>
                          <DropdownToggle color={useSimpleType ? "primary" : "secondary"} caret className="mx-0"><Trans>Report to Zatca</Trans></DropdownToggle>
                          <DropdownMenu>
                            {/* <DropdownItem onClick={() => checkZatcaResend(() => sendToZatcaHandler(invoiceSDKZatca, false, preHandleSDKPost))}>
                              <Trans>Send to Compliance</Trans>
                            </DropdownItem> */}
                            {!(reportedList?.reported || reportedList?.cleared) &&
                              <DropdownItem onClick={() => checkZatcaResend(() => sendToZatcaHandler(invoiceSDKZatca, true, preHandleSDKPost))}>
                                <Trans>Send to {useSimpleType ? "Clearance" : "Reporting"}</Trans>
                              </DropdownItem>
                            }
                            {reportedList?.response &&
                              <DropdownItem onClick={() => { setErrorWindow(true); }}>
                                <Trans>View Response</Trans>
                              </DropdownItem>
                            }
                            <DropdownItem onClick={() => { sendToZatcaHandler(invoiceSDKZatca, false, preGetInvoiceXML) }}>
                              <Trans>Download as XML</Trans>
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>) : (<Button disabled className="mx-0"><span className="fa fa-spinner fa-spin" /> <Trans>Sending</Trans></Button>)}
                    </div>
                  )}
                  <div className="col px-1 flex-grow-0 px-1">
                    <PackingSlipCell label="Packing Slip" i={item} componentDoc={PackingSlipDocument} selectedOrganisation={selectedOrganisation} />
                  </div>
                  {item.Attachments && (
                    <div className="col flex-grow-0 px-1">
                      <Attachments
                        xero={xero}
                        onAttachmentsChanged={handleAttachmentsChanged}
                        baseUrl={`invoices/${item.InvoiceID}`}
                        attachments={item.Attachments}
                      />
                    </div>
                  )}
                </>
              }
            </div>

            <div className="col-lg-12 col-xl-7 row px-4 justify-content-end">
              {!!item.InvoiceID &&
                <>
                  <div className="col px-1 flex-grow-0">
                    <DownloadCell simplified={useSimpleType} componentDoc={selectedType} selectedOrganisation={selectedOrganisation} validation={validateDownload} setDownloadHandler={setDownloadHandler} i={{ ...items, ...invoiceSDKZatca, IsSimplified: useSimpleType, DocumentType: documentType }} />
                  </div>
                  <div className="col px-1 flex-grow-0">
                    <EmailCell type="BULK_INVOICES" simplified={useSimpleType} componentDoc={selectedType} selectedOrganisation={selectedOrganisation} validation={validateDownload} setDownloadHandler={setDownloadHandler} i={{ ...items, ...invoiceSDKZatca, IsSimplified: useSimpleType, DocumentType: documentType }} />
                  </div>
                  <div className="col px-1 flex-grow-0">
                    <PrintCell simplified={useSimpleType} i={item} componentDoc={selectedPrintCell} selectedOrganisation={selectedOrganisation} />
                  </div>
                  <div className="col px-1 flex-grow-0">
                    <ShareCell simplified={useSimpleType} componentDoc={selectedType} selectedOrganisation={selectedOrganisation} validation={() => checkInvoiceDownload(true)} setDownloadHandler={setDownloadHandler} i={{ ...items, ...invoiceSDKZatca, IsSimplified: useSimpleType, DocumentType: documentType }} />
                  </div>
                  {(item.Status === "DRAFT" || item.Status === "SUBMITTED") && (
                    <div className="col px-1 flex-grow-0">
                      <Link
                        type="button"
                        className="btn-sm btn btn-primary mx-0"
                        to={`/accounts_receivable/invoices/edit/${item.InvoiceID}`}>
                        <Trans>Edit Invoice</Trans>
                      </Link>
                    </div>
                  )}
                  {(item.Status === "PAID" || item.Status === "AUTHORISED") && (
                    <div className="col px-1 flex-grow-0">
                      <InvoiceOptions />
                    </div>
                  )}
                  {item.Status === "AUTHORISED" && (
                    <div className="col px-1 flex-grow-0">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn-sm btn btn-primary mx-0"
                          onClick={togglePaymentVisibility}>
                          {isPaymentVisible ? t('Hide Payment') : t('Add Payment')}
                        </button>
                      </div>
                    </div>
                  )}
                </>
              }
            </div>
          </div>
          <LocalForm className="mt-3 inv-table"
            onSubmit={onSubmit}
            validators={{
              Name: { required },
              Date: { required },
              "LineItems[].Description": { required },
            }}
          >
            <Row>
              <Col {...cStyle.common}>
                <FormGroup label="To" model=".Name" >
                  <Link to={`/contacts/view/${item?.Contact?.ContactID}`} {...cStyle.status}>
                    {item?.Contact?.Name}
                  </Link>
                </FormGroup>
              </Col>
              <Col {...cStyle.common}>
                <FormGroup label="Status">
                  <SpanColor>{getStatus(item.Status)}</SpanColor>
                </FormGroup>
              </Col>
              <Col {...cStyle.common}>
                <FormGroup label="Date" model=".Date">
                  <SpanColor>{formatedDate(item.Date) || "---"}</SpanColor>
                </FormGroup>
              </Col>
              <Col {...cStyle.common}>
                <FormGroup label="Due Date" model=".DueDate">
                  <SpanColor>{formatedDate(item.DueDate) || "---"}</SpanColor>
                </FormGroup>
              </Col>
              <Col {...cStyle.common}>
                <FormGroup
                  label="Supply Date"
                  model=".ExpectedPaymentDate">
                  <SpanColor>{formatedDate(item.ExpectedPaymentDate) || "---"}</SpanColor>
                </FormGroup>
              </Col>
              {/* ----- Temporary hiding ------- */}
              {/* <Col {...cStyle.common}>
                <FormGroup label="Hessab Invoice Number #" model=".InvoiceNumber">
                  <SpanColor>{item.HesaabNumber ||item.InvoiceNumber}</SpanColor>
                </FormGroup>
              </Col> */}
              {/* <Col {...cStyle.common}>
                <FormGroup label="Xero Invoice Number #" model=".InvoiceNumber">
                  <SpanColor>{item.InvoiceNumber}</SpanColor>
                </FormGroup>
              </Col> */}
              {/* ----- Temporary hiding ------- */}
              {/* Temporary Showing */}
              <Col {...cStyle.common}>
                <FormGroup label="Invoice Number" model=".InvoiceNumber">
                  <SpanColor>{item.InvoiceNumber}</SpanColor>
                </FormGroup>
              </Col>
              {/* Temporary Showing */}
              <Col {...cStyle.common}>
                <FormGroup label="Reference" model=".Reference">
                  <SpanColor>{items.Reference || '---'}</SpanColor>
                </FormGroup>
              </Col>
            </Row>
            <hr />
            <LineItemsView
              organisation={organisation}
              item={item}
              includeDiscount={item.Type === 'ACCREC'}
              dispatch={dispatch}
              xero={xero}
              hideAccountAndTax={false}
              invoiceType="Invoice"
              prepayments={prepayments}
              reload={reload}
            />
            <HistoryComponent historyItem={historyItem} type="Invoice" t={t} />
          </LocalForm>
        </>
          :
          <><BackButton /><div className="text-center" style={{ fontSize: "1.3em" }}><p><Trans>The ID was not found, please make sure to check once and try again.</Trans></p></div></>
        }
      </Page>
      {
        isPaymentVisible && (
          <div ref={pageTakeOver} className="centered-container">
            <Payment
              invoice={item}
              organisation={organisation}
              onPaymentAdded={handlePaymentAdded}
              xero={xero}
            />
          </div>
        )
      }
      <MainModal title={t('Set Invoice details')}>
        <DownloadError setInvoice={setItems} item={item} toggle={toggle} history={history} missFields={missFields} callbackFunc={reload} />
      </MainModal>

      <NoTaxComponent formattedType={formattedType} invoiceSDKZatca={invoiceSDKZatca} setSDKZatcaData={setSDKZatcaData} selectedZatcaApp={selectedZatcaApp} setSelectedZatcaApp={setSelectedZatcaApp}></NoTaxComponent>
      <TaxExemptComponent />
      <ZatcaAppsComponent selectedZatcaApp={selectedZatcaApp} callbackFunc={callbackFunc} />

      <MainResendModal title={t('Resend Confirmation')} action={t("Confirm")}>
        <Alert color="warning">
          <Trans>This invoice is already reported to Zatca, Do you want to report it again?</Trans>
        </Alert>
      </MainResendModal>
      {errorWindow && reportedList?.response && <ErrorDetailsComponent show={errorWindow} handleClose={() => { setErrorWindow(false); }} details={reportedList.response} typeOfInv={formattedType} showWarnings={true} reload={() => { }} />}
    </div>
  );
};

const enhance = compose(
  withOrganisationContextConsumer,
  withReload(),
  onMount(({ match, xero, location, fetchOrganisation }) => async () => {
    const { id } = match.params;
    const item = await xero
      .get(`invoices/${match.params.id}`)
      .get("data")
      .then((item) => ({
        ...item,
        LineItems: item?.LineItems?.map((i) => ({
          ...i,
          _id: shortid(),
        })),
        hasZeroTax: item?.LineItems.some((i) => (i.TaxAmount || 0) === 0),
      }));
    const invHistory = await xero
      .get(`invoices/${match.params.id}/History`)
      .get("data")
      .then((invHistory) => ({
        ...invHistory,
      }));
    let remainingCredit = 0;
    let prepayments = [];
    if (item?.Status === 'AUTHORISED' && ['ACCREC', 'ACCPAY'].includes(item?.Type)) {
      const prepayment_type = item?.Type === 'ACCREC' ? 'RECEIVE-PREPAYMENT' : 'SPEND-PREPAYMENT';
      prepayments = await xero
        .get(`prepayments`,
          {
            params: {
              raw: `Contact.ContactID=GUID("${item?.Contact?.ContactID}") AND Status="AUTHORISED" AND TYPE="${prepayment_type}"`,
            },
          }
        )
        .get("data")
      remainingCredit = prepayments?.reduce((total, prepayment) => total + prepayment.RemainingCredit, 0);
    }

    const organisation = await fetchOrganisation();
    return {
      item: { ...item, RemainingCredit: remainingCredit },
      invHistory,
      organisation,
      prepayments,
    };
  }),
  withLocalForm({
    initialState: ({ item }) => item,
    stateKey: "item",
    formKey: "form",
  }),
  withXeroErrors(),
  withHandlers({
    handleAttachmentsChanged:
      ({ xero, match, dispatch }) =>
        () => {
          xero
            .get(`invoices/${match.params.id}/attachments`)
            .get("data")
            .tap((d) => dispatch(actions.change("local.Attachments", d)));
        },
    handlePaymentAdded:
      ({ reload }) =>
        () => {
          reload();
        },
  }),
  withOptions(),
  withDocumentRenderer({
    onDownload:
      ({ item, xero }) =>
        (getDocument) =>
          getDocument(
            {
              item: { ...item, ALPHA: 123 },
            },
            `invoice_${item.InvoiceNumber}.pdf`
          ),
    type: "SALES_INVOICE",
  })
);

export default enhance(ViewEInvoice);